export enum PageType {
    ResetPaymentPassword = 'reset_payment_password', // 重置付款密码
    VerifySecurityAccount_BindLoginAccount = 'verify_security_account_bind_login_account', // 绑定登录账号时前置验证安全账号
    VerifySecurityAccount_SetSecurityAccount = 'verify_security_account_set_security_account', // 绑定安全账号时前置验证安全账号
    BindLoginAccount = 'bind_login_account', // 验证绑定的登录账号，邮箱手机号
    UnbindLoginAccount = 'unbind_login_account', // 解绑登录账号
    SetSecurityAccount = 'set_security_account', // 设置安全账号
}
